import { useEffect } from 'react';

import { ComboboxItem, Select, Text, TextInputProps } from '@mantine/core';

import { useIcon } from '@/shared/hooks/useIcon';

import classes from './CarPassSelector.module.css';

type CarPassSelectorProps = {
	value?: string;
	carPasses?: Array<ComboboxItem>;
	onChange: (selectedCarNumber: string | null) => void;
	onAutoSelect?: (selectedCarNumber: string) => void;
} & TextInputProps;

export const CarPassSelector = ({
	value,
	carPasses,
	onChange,
	onAutoSelect = onChange,
	error,
}: CarPassSelectorProps) => {
	const icon = useIcon({ type: 'car', size: 24 });

	useEffect(() => {
		if (carPasses?.length && !carPasses.some((pass) => pass.value === String(value))) {
			onAutoSelect(carPasses[0].value);
		}
	}, [carPasses]);

	if (!carPasses) return null;

	return (
		<Select
			classNames={classes}
			label={
				<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
					Номер автомобиля
				</Text>
			}
			placeholder="А000АА000"
			data={carPasses}
			rightSection={icon}
			allowDeselect={false}
			onChange={onChange}
			error={error}
			value={carPasses?.find((pass) => pass.value === String(value))?.value ?? carPasses[0]?.value}
		/>
	);
};
